
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50 dark:from-fraudeye-primary dark:to-fraudeye-secondary">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center text-center space-y-8">
          <div className="space-y-4 max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold tracking-tighter">
              Advanced Fraud Detection for the AI Era
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              FraudEye provides powerful, comprehensive tools to detect AI-generated content, deepfakes, and fraudulent media across multiple formats.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-fraudeye-accent hover:bg-fraudeye-highlight">
              <Link to="/dashboard">Try It Now</Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/contact">Contact Sales</Link>
            </Button>
          </div>
          <div className="relative w-full max-w-4xl mt-8 rounded-xl overflow-hidden shadow-2xl">
            <img 
              src="https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
              alt="FraudEye Dashboard Preview" 
              className="w-full object-cover h-[500px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
              <div className="p-6 text-white text-left">
                <h3 className="text-xl font-bold">Comprehensive Dashboard</h3>
                <p className="text-sm opacity-90">Monitor and analyze multiple types of content with our intuitive interface</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
